var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"form-section"},[(_vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"row p-2 mb-3",class:_vm.classes,style:(_vm.containerStyle)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }